module.exports = __webpack_public_path__ + "static/media/Icona-4.087c2937.svg";